import {
  type Locale,
  SUPPORTED_LOCALES,
} from "../../../shared/constants/locales";

export const DEFAULT_LOCALE: Locale = "en";

export function isSupportedLocale(
  value: string | null | undefined,
): value is Locale {
  return (
    typeof value === "string" &&
    (SUPPORTED_LOCALES as readonly string[]).includes(value)
  );
}

export function getClosestSupportedLocale(
  language: string | null | undefined,
): Locale | null {
  if (!language) return null;

  const normalizedLanguage = language.toLowerCase().replaceAll("_", "-");
  const primaryLanguage = normalizedLanguage.split("-")[0];

  if (isSupportedLocale(normalizedLanguage)) return normalizedLanguage;
  if (isSupportedLocale(primaryLanguage)) return primaryLanguage;

  return null;
}

export function getBrowserPreferredLocale(): Locale {
  if (typeof navigator === "undefined") return DEFAULT_LOCALE;

  const browserLanguages = [
    ...(navigator.languages ?? []),
    navigator.language,
  ].filter(Boolean);

  for (const language of browserLanguages) {
    const locale = getClosestSupportedLocale(language);

    if (locale) return locale;
  }

  return DEFAULT_LOCALE;
}

export function getLocaleSearchParam(
  searchParams: URLSearchParams,
): Locale | null {
  return getClosestSupportedLocale(searchParams.get("lang"));
}
